import { render, staticRenderFns } from "./RatingWidget.vue?vue&type=template&id=05d4215e"
import script from "./RatingWidget.vue?vue&type=script&lang=js"
export * from "./RatingWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingWidget.vue?vue&type=style&index=0&id=05d4215e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports